import React, { useState, useMemo } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Avatar,
  Chip,
  InputAdornment,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import roleIcon from "@assets/svg/roleIcon.svg";
import GenericBreadCrums from "@components/Breadcrumbs";
import { bgcolor } from "@mui/system";


// Mock data - replace with actual API call
const MOCK_MEMBERS = [
  {
    id: 1,
    name: "Sophie Kim",
    role: "Highway Engineer",
    email: "sophie.kim@techcorp.com",
    phone: "+91-91234-56789",
    status: "Active",
    initials: "SK",
  },
  {
    id: 2,
    name: "Rajesh Dutta",
    role: "Bridge Engineer",
    email: "rajesh.dutta@designhub.com",
    phone: "+91-99876-54321",
    status: "Inactive",
    initials: "RD",
  },
  {
    id: 3,
    name: "Mina Patel",
    role: "GIS Analyst",
    email: "mina.patel@analytics.com",
    phone: "+91-98765-67890",
    status: "Active",
    initials: "MP",
  },
  {
    id: 4,
    name: "Maya Kumar",
    role: "CAD Designer",
    email: "maya.kumar@designhub.com",
    phone: "+91-98765-87890",
    status: "In active",
    initials: "MK",
  },
  {
    id: 5,
    name: "Rajesh Singh",
    role: "Chief Engineer",
    email: "rajesh.singh@products.com",
    phone: "+91-98765-54321",
    status: "In active",
    initials: "RS",
  },
  {
    id: 6,
    name: "Leena Patil",
    role: "Road Construction Manager",
    email: "leena.patil@analytics.com",
    phone: "+91-98765-98765",
    status: "In active",
    initials: "LP",
  },
  {
    id: 7,
    name: "Bhavna Kapoor",
    role: "Survey Engineer",
    email: "bhavna.kapoor@design.co.in",
    phone: "+91-98765-67890",
    status: "Active",
    initials: "BK",
  },
  {
    id: 8,
    name: "Bhavna Kapoor",
    role: "Transportation Planner",
    email: "bhavna.kapoor@design.co.in",
    phone: "+91-98765-67890",
    status: "Active",
    initials: "BK",
  },
  {
    id: 9,
    name: "Bhavna Kapoor",
    role: "Traffic Engineer",
    email: "bhavna.kapoor@design.co.in",
    phone: "+91-98765-67890",
    status: "In active",
    initials: "BK",
  },
];

const getStatusColor = (status: string) => {
  switch (status) {
    case "Active":
      return { bg: "#DBEFDC", color: "#2E7D32" };
    case "Inactive":
      return { bg: "#E8E8E8", color: "#616161" };
    case "In active":
      return { bg: "#E8E8E8", color: "#616161" };
    default:
      return { bg: "#F5F5F5", color: "#424242" };
  }
};

export const SpocMembers: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Status");

  // Filter members
  const filteredMembers = useMemo(() => {
    return MOCK_MEMBERS.filter((member) => {
      const matchesSearch =
        member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        member.phone.includes(searchTerm);

      const matchesStatus =
        statusFilter === "All Status" || member.status === statusFilter;

      return matchesSearch && matchesStatus;
    });
  }, [searchTerm, statusFilter]);

  const handleAddSpoc = () => {
    // Navigate to add SPOC form or open modal
    navigate("/add-spoc");
  };

  const handleViewDetails = (member: any) => {
    navigate(`/org-admin/spoc-members/details/${member.id}`, { state: { member } });
  };

  return (



// ===========
 <Box className="app-details-wrapper login-root">
      <div className="page-content">
        {/* <GenericBreadCrums  className="mt-6" /> */}

        <Box className="app-details-card" style={{ backgroundColor: "transparent" }}>
          {/* Banner */}
          <Box className="application-banner">
            {/* Banner Header */}
            <Box
              className="application-banner-header"
              sx={{ gap: { xs: 2, sm: 0 } }}
            >
              <Typography className="application-id flex gap-4 items-center">
                SPOC Members

              </Typography>

              <Box
                className="banner-buttons"
                sx={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: { xs: "flex-start" },
                }}
              >
                {/* <Button
                  variant="outlined"
                  className="btn-outline-purple"
                  // startIcon={<EditOutlinedIcon />}
                  onClick={() => navigate("/org-admin/spoc-members/edit/1")}
                  sx={{
                    border: "1px solid #3a1c73 !important",
                    borderRadius: "50px !important",
                    background: "#fff",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#3a1c73",
                  }}
                >
                  Edit Details
                </Button> */}
                 <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddSpoc}
          sx={{
            bgcolor: "#3A1C73",
            color: "white",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "14px",
            px: 2.5,
            py: 1,
            borderRadius: "50px",
            "&:hover": {
              bgcolor: "#4A2D7A",
            },
          }}
        >
          Add SPOC
        </Button>

              </Box>
            </Box>

            {/* Sub-info bar */}
            <Box
              className="application-subinfo"
              sx={{
                flexWrap: "wrap",
                gap: { xs: 1, md: 2 },
                mt: { xs: 2, md: 0 },
              }}
            >
              <Typography className="app-date">
                <strong>{filteredMembers.length} Members found
</strong>
              </Typography>

            </Box>



            <br />
            {/* <Divider className="app-divider" /> */}
            <br />

            {/* Avatar summary bar */}
            {/* Search and Filter Section */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 3,
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <TextField
          placeholder="Search by Name, Mobile Number"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#212121", fontSize: "18px", fontWeight: 500 }} />
              </InputAdornment>
            ),
          }}
          sx={{
            flex: 1,
            minWidth: "300px",
            "& .MuiOutlinedInput-root": {
              bgcolor: "white",
              borderRadius: "8px",
            },
          }}
        />

        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
          }}
        >

          <Box
            component="select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            sx={{
              padding: "8px 12px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              bgcolor: "white",
              cursor: "pointer",
              fontSize: "14px",
              outline: "none",
              "&:hover": {
                borderColor: "#999",
              },
            }}
          >
            <option value="All Status">All Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="In active">In active</option>
          </Box>
        </Box>
      </Box>

      {/* Members Grid */}
      {filteredMembers.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            py: 8,
            color: "#757575",
          }}
        >
          <Typography variant="body1">
            No members found matching your search.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2.5}>
          {filteredMembers.map((member) => {
            const statusColors = getStatusColor(member.status);
            return (
              <Grid item xs={12} sm={6} md={4} key={member.id}>
                <Card
                  sx={{
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    "&:hover": {
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <CardContent sx={{ p: 2.5, pb: 2 }}>
                    {/* Avatar and Status */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        mb: 1.5,
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 48,
                          height: 48,
                          bgcolor: "#E8E8E8",
                          color: "#757575",
                          fontWeight: 600,
                          fontSize: "18px",
                        }}
                      >
                        {member.initials}
                      </Avatar>
                      <Chip
                        label={member.status}
                        size="small"
                        sx={{
                          bgcolor: statusColors.bg,
                          color: statusColors.color,
                          fontWeight: 500,
                          fontSize: "12px",
                        }}
                      />
                    </Box>

                    {/* Name */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#212121",
                        mb: 0.5,
                        fontSize: "16px",
                      }}
                    >
                      {member.name}
                    </Typography>

                    {/* Role */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#757575",
                        mb: 1.5,
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <img
            src={roleIcon}
            alt="role"
            style={{ width: 14, height: 14 }}
          />
                      </Box>
                      {member.role}
                    </Typography>

                    {/* Email */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#757575",
                        mb: 0.75,
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        wordBreak: "break-word",
                      }}
                    >
                      <MailOutlineIcon sx={{ fontSize: "16px", flex: "0 0 auto" }} />
                      <span style={{ wordBreak: "break-all" }}>{member.email}</span>
                    </Typography>

                    {/* Phone */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#757575",
                        mb: 2,
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                      }}
                    >
                      <PhoneIcon sx={{ fontSize: "16px" }} />
                      {member.phone}
                    </Typography>

                    {/* View Details Link */}
                    <Box
                      sx={{
                        mt: "auto",
                        pt: 1.5,
                        borderTop: "1px solid #eee",
                      }}
                    >
                      <Button
                        onClick={() => handleViewDetails(member)}
                        sx={{
                          textTransform: "none",
                          color: "#5E3B9F",
                          p: 0,
                          fontSize: "14px",
                          fontWeight: 500,
                          "&:hover": {
                            bgcolor: "transparent",
                            textDecoration: "underline",
                          },
                        }}
                      >
                        View Details
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
          </Box>


        </Box>
      </div>
    </Box>
// ============
  );
};
